import { createTheme } from '@material-ui/core/styles'

export const createTableTheme = ({ layoutType, uischema, title }) => {
  let colorText = layoutType === 'dark' ? '#adb7be' : '#000000' + ' !important'
  let colorPagination =
    layoutType === 'dark'
      ? 'rgba(255, 255, 255, 0.54)'
      : 'rgba(0, 0, 0, 1)' + ' !important'

  return createTheme({
    overrides: {
      MuiMenu: {
        paper: {
          backgroundColor: 'white',
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: 'transparent',
          maxWidth: uischema.maxWidth || '100%',
          '& [class*="Component-horizontalScrollContainer-"]': {
            backgroundColor: 'transparent',
            color: colorText,
            display: 'inline-grid',
            width: '100%',
          },
        },
      },
      MuiToolbar: {
        regular: {
          display: title || uischema?.tableAction?.searchable ? 'flex' : 'none',
        },
      },
      MuiTableRow: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: uischema.rowColor1 || 'transparent',
            color: uischema.rowTextColor1 || colorText,
            '& [class*="MuiTableCell-body-"]': {
              color: uischema.rowTextColor1 || colorText,
            },
          },
          '&:nth-of-type(even)': {
            backgroundColor: uischema.rowColor2 || 'transparent',
            color: uischema.rowTextColor2 || colorText,
            '& [class*="MuiTableCell-body-"]': {
              color: uischema.rowTextColor2 || colorText,
            },
          },
          '& [class*="ForwardRef(MTableHeaderRef)-header-"]': {
            backgroundColor: 'transparent',
            color: colorText,
          },
          '& [class*="Mui-disabled"]': {
            cursor: 'default',
            pointerEvents: 'auto',
          },
        },
      },
      MuiTableHead: {
        root: {
          '& [class*="MuiTableRow-"]': {
            backgroundColor: uischema.headerColor + ' !important',
          },
          '& [class*=" MuiTableCell-head"]': {
            color: uischema.headerTextColor + ' !important',
            fontWeight: uischema.headerBold ? 'bold' : 'normal' + ' !important',
          },
        },
      },
      MuiTableFooter: {
        root: {
          '& [class*="MuiTableRow-"]': {
            backgroundColor: 'transparent !important',
            color: colorText,
          },
          '& [class*="MuiToolbar-"]': {
            display: 'flex',
            backgroundColor: 'transparent !important',
            color: colorText,
          },
          '& [class*="ForwardRef(MTablePaginationRef)-"]': {
            backgroundColor: 'transparent !important',
            color: colorText,
          },
          '& [class*="MuiIconButton-"]': {
            backgroundColor: 'transparent !important',
            color: colorPagination,
          },
        },
      },
      MuiList: {
        root: {
          backgroundColor: 'transparent',
          color: colorText,
        },
      },
    },
  })
}
